var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFourCategoryIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_130)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 6,
    height: 22,
    stroke: "#5D0D19",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.29999,
    y: 1,
    width: 6,
    height: 22,
    stroke: "#5D0D19",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.6,
    y: 1,
    width: 6,
    height: 22,
    stroke: "#5D0D19",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9,
    y: 1,
    width: 6,
    height: 22,
    stroke: "#5D0D19",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourCategoryIc);
export default __webpack_public_path__ + "static/media/four_category_ic.a8f79d9afa9c599ca7820430aeecb4c9.svg";
export { ForwardRef as ReactComponent };